import React from "react";

export {HeaderMailValidation};

const HeaderMailValidation = (props: any) => {
  
  return(<div className={"page-layout__header-mail-unverified"}>
    Mail non validé
  </div>)
}